import { ref, computed } from 'vue';

/** Global: set of remoteIds currently generating replays. Multiple flights can generate in parallel. */
const generatingReplayIds = ref<Set<string>>(new Set());

function setGenerating(remoteId: string, generating: boolean): void {
  const next = new Set(generatingReplayIds.value);
  if (generating) next.add(remoteId);
  else next.delete(remoteId);
  generatingReplayIds.value = next;
}

function isGenerating(remoteId: string): boolean {
  return generatingReplayIds.value.has(remoteId);
}

function getGeneratingReplayIds(): string[] {
  return [...generatingReplayIds.value];
}

export { setGenerating, isGenerating, getGeneratingReplayIds };

export function useReplayGenerating() {
  return {
    generatingReplayIds: computed(() => generatingReplayIds.value),
    setGenerating,
    isGenerating,
    getGeneratingReplayIds,
  };
}
